import { SinTipoDocumentoSectorProps } from '../../interfaces/sin.interface'

type ImageType = 'thumbnail' | 'square' | 'medium'

/**
 * @description Urls de las variantes de imagenes
 * Asociada al alrticulo
 */
export interface ImagenCloudProp {
  id: string // id unico
  filename: string // nombre del archivo
  variants: { [Key in ImageType]: ImageType } // objeto de variantes thumball, public, medium, etc
}

/**
 * @description Modelo de Periodo
 */
export interface KardexPeriodoProps {
  codigo: number
  descripcion: string
  documentoSector: SinTipoDocumentoSectorProps
  state?: string
  usucre?: string
  createdAt?: Date
  usumod?: string
  updatedAt?: string
}

export interface KardexPeriodoInput {
  descripcion: string
  codigoDocumentoSector: number | null
}
export const KARDEX_PERIODO_INITIAL_VALUES: KardexPeriodoInput = {
  descripcion: '',
  codigoDocumentoSector: null,
}
